// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.644 11.994c0-.35.15-.7.4-.95l4.8-4.75c.35-.35.9-.35 1.25 0s.35.9 0 1.25l-4.35 4.35c-.05.05-.05.15 0 .2l4.35 4.35c.35.35.35.9 0 1.25s-.9.35-1.25 0l-4.75-4.75c-.3-.25-.45-.6-.45-.95z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>";
// Exports
module.exports = code;